/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_CATEGORY_URL, API_SKU_URL, COMMON_HEADER_CONFIG} from "src/config";

class CampaignPriceService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getCampaignList = (params) => {
    return new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_SKU_URL}/campaigns`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => reject(error));
    });
  };

  editStatusCampaign = (id, data) => {
    return new Promise((resolve, reject) => {
      const config = {
        method: "patch",
        url: `${API_SKU_URL}/campaigns/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => reject(error));
    });
  };

  getOneCampaignPrice = (id) => {
    return new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_SKU_URL}/campaigns/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => reject(error));
    });
  };

  editCampaignPrice = (id, data) => {
    return new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_SKU_URL}/campaigns/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => reject(error));
    });
  };

  createCampaign = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_SKU_URL}/campaigns`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };
      axios(config)
        .then((res) => {
          if (res.data && res.data.code === "success") {
            resolve(res.data.data);
          } else {
            reject(res.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getCategory = () => {
    return new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CATEGORY_URL}/child/get-deepest`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  updateCampaign = (id, data) => {
    return new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_SKU_URL}/campaigns/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };
      axios(config)
        .then((res) => {
          if (res.data && res.data.code === "success") {
            resolve(res.data);
          } else {
            reject(res.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
}
const campaignPriceService = new CampaignPriceService();
export default campaignPriceService;
